module.exports = __webpack_public_path__ + "img/fastcharger-suggestion-private.93c4b1b6.png";